export default __webpack_public_path__ + "static/media/brave_zone_background_xl1.0c6bccde.jpg";